import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue, FctValue27, FctValue40 } from '../../../../Fct/generics';
import { FaChartBar } from 'react-icons/fa';
import { getAaveTokens } from '../../../../Fct/plugins/allowanceRequiredProtocols';
import { PROTOCOL_DATA_PROVIDER_ADDRESSES } from '../constants';
export var GetAssetReserveData = createPlugin({
    protocol: 'AAVE',
    type: 'GETTER',
    method: 'getReserveData',
    name: 'getAssetReserveData',
    supportedContracts: PROTOCOL_DATA_PROVIDER_ADDRESSES,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({ destination: 'aave_protocol_data_provider_v2' }),
                methodParams: {
                    asset: new FctAddress({ destination: 'erc20', options: getAaveTokens({ chainId: chainId }), isPreview: true, icon: FaChartBar }),
                },
            },
            output: {
                availableLiquidity: new FctValue({ innerIndex: 0 }),
                totalStableDebt: new FctValue({ innerIndex: 1 }),
                totalVariableDebt: new FctValue({ innerIndex: 2 }),
                supplyRate: new FctValue27({ innerIndex: 3 }),
                variableBorrowRate: new FctValue27({ innerIndex: 4 }),
                stableBorrowRate: new FctValue27({ innerIndex: 5 }),
                averageStableBorrowRate: new FctValue({ innerIndex: 6 }),
                liquidityIndex: new FctValue({ innerIndex: 7 }),
                variableBorrowIndex: new FctValue({ innerIndex: 8 }),
                lastUpdateTimestamp: new FctValue40({ innerIndex: 9 }),
            },
        });
    },
});
